import { render } from "./vitalSignsResultOvertime.vue?vue&type=template&id=f8a5f5ca&scoped=true"
import script from "./vitalSignsResultOvertime.js?vue&type=script&lang=js"
export * from "./vitalSignsResultOvertime.js?vue&type=script&lang=js"

import "./vitalSignsResultOvertime.vue?vue&type=style&index=0&id=f8a5f5ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a5f5ca"]])

export default __exports__